export default class SviatokService{

  constructor(server){
    this.server = server;
    this._listPromise = null;
  }

  list(){
    return this.server("listSviatky");
  }

  cachedList(){
    if(!this._listPromise) this._listPromise = this.list();
    return this._listPromise;
  }

  save(item){
    return this.server("saveSviatok", {nazov: item.nazov, datum: item.datum});
  }

  remove(item){
    return this.server("removeSviatok", {id: item.id});
  }

  update(item){
    return this.server("saveSviatok", {id: item.id, nazov: item.nazov, datum: item.datum});
  }


}


// WEBPACK FOOTER //
// ./src/services/SviatokService.js